import {FC, PropsWithChildren, useContext} from 'react';
import {Navigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {authState} from '../../store/auth/atoms';
import Fallback from '../../ui/fallback/Fallback';
import {AuthContext} from '../AuthContextProvider';

const GuestRoute: FC<PropsWithChildren> = ({children}) => {
  const {isLoggedIn, isFirstLogin} = useRecoilValue(authState);
  const {loading} = useContext(AuthContext);

  if (loading || isFirstLogin) return <Fallback />;

  return isLoggedIn ? <Navigate to="/" replace /> : <>{children}</>;
};

export default GuestRoute;
